import { useEffect, useRef, useState } from 'react';

type Position = 'initial' | 'absolute' | 'relative' | 'fixed' | 'sticky';

export const usePositionFixedOnScroll = (id: string, initialPosition: Position = 'absolute') => {
  const [position, setPosition] = useState<Position>(initialPosition);
  const initialTop = useRef(0);

  useEffect(() => {
    const onScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const el = document.getElementById(id);

      if (!el) return;

      const offset = el.getBoundingClientRect();

      if (offset.top > 0) {
        initialTop.current = offset.top + currentScrollPos;
        if (currentScrollPos >= initialTop.current) {
          setPosition('fixed');
        } else {
          setPosition(initialPosition);
        }
      } else {
        if (initialTop.current < currentScrollPos) {
          setPosition('fixed');
        } else {
          setPosition(initialPosition);
        }
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => window.removeEventListener('scroll', onScroll);
  }, [id, initialPosition]);

  return { position };
};
